import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { AbstractModel, Collection, CollectionDictionary } from 'taxtank-core';

/**
 * Pipe returns collection by key from dictionary. Works with async data
 */
@Pipe({
  name: 'dictionaryAsync',
  standalone: false
})
export class DictionaryAsyncPipe implements PipeTransform {
  transform(dictionary$: Observable<CollectionDictionary<Collection<AbstractModel>>>, key: string | number): Observable<Collection<AbstractModel>> {
    return dictionary$.pipe(
      map((dictionary: CollectionDictionary<Collection<AbstractModel>>): Collection<AbstractModel> => dictionary.get(key))
    );
  }
}
